export default "__VITE_ASSET__DlJmp_bN__"